import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal } from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'

import { toast } from 'react-toastify'
import {
  ApplyRoomChange,
  getRoomAllocationList,
  AvailableRoomsData,
  GetAvailableRoom,
  GetBedMasterById,
  GetClassMaster,
  GetRoomMaster,
  IMG_BASE_URL,
} from '../../../AllAPI/AdminAPI'
import { GetFeeApprovedList } from '../../../AllAPI/AdminAPI'
import * as XLSX from 'xlsx'

const StudentRoomChange = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [loading, setLoading] = useState(false)

  const [allotModalOpen, setAllotModalOpen] = useState(false)
  const [rooms, setRooms] = useState([])
  const [beds, setBeds] = useState([])
  const [selectedRoomId, setSelectedRoomId] = useState(null)
  const [selectedBedId, setSelectedBedId] = useState(null)
  const [rejectModalOpen, setRejectModalOpen] = useState(false)
  const [rejectReason, setRejectReason] = useState('')
  const [classes, setClasses] = useState([])
  const [selectedClassId, setSelectedClassId] = useState(null)

  useEffect(() => {
    fetchFeeApprovedStudentList()
  }, [])

  const fetchClasses = async () => {
    try {
      const res = await axios.get(`${GetClassMaster}/${storedBranchId}`)
      setClasses(res.data)
    } catch (err) {
      toast.error('Failed to load classes')
    }
  }

  const fetchRooms = async (classId) => {
    try {
      const res = await axios.get(`${AvailableRoomsData}/${classId}`)
      if (Array.isArray(res.data)) {
        setRooms(res.data)
      } else {
        setRooms([])
        if (res.data === 'NO_ROOMS_FOUND') {
          toast.warning('No rooms available for selected class')
        }
      }
    } catch (err) {
      toast.error('Failed to load rooms')
      setRooms([])
    }
  }

  const fetchBeds = async (roomId) => {
    try {
      const res = await axios.get(
        `${GetBedMasterById}/${storedBranchId}/${roomId}`,
      )
       console.log(res.data);   // <-- Add this
      setBeds(res.data)
    } catch (err) {
      toast.error('Failed to load beds')
    }
  }

  const fetchFeeApprovedStudentList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${getRoomAllocationList}/${storedBranchId}/${BoardingYear}`,
      )

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        whats_no: item.wh_mobile || '-',
         class_name: item.roombooking.class.class_name || '-',
        room: item.roombooking.room.room_no || '-',
        bed: item.roombooking.bed.bed_no || '-',
        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.whats_no ?? '').toString().includes(search) ||
      (item.hostel_tax_id ?? '').toLowerCase().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'WhatsApp No', dataIndex: 'whats_no' },
    { title: 'Building', dataIndex: 'class_name' },
    { title: 'Room', dataIndex: 'room' },
    { title: 'Bed', dataIndex: 'bed' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]

  const handleApproval = async () => {
    if (!selectedRecord) return
    if (!selectedClassId) {
      toast.warning('Please select class')
      return
    }

    const today = new Date().toISOString().split('T')[0]

    const body = {
      reg_id: parseInt(selectedRecord.reg_id),
      branch_id: parseInt(selectedRecord.branch_id),
      class_id: parseInt(selectedClassId),
      oldroom_id: parseInt(selectedRecord.roombooking.room_id),
      oldbed_id: parseInt(selectedRecord.roombooking.bed_id),

      // 👉 Use selected room/bed from allocation modal
      newroom_id: parseInt(selectedRoomId),
      newbed_id: parseInt(selectedBedId),
      change_date: today,
      year: parseInt(BoardingYear),
    }

    try {
      setLoading(true)
      const res = await axios.put(ApplyRoomChange, body)

      if (res.data === 'BEDNOTAVAILABLE') {
        toast.warn('Bed not available')
      } else if (res.data === 'REQUIRED') {
        toast.warn('Required data not found!')
      } else if (res.data === 'ROOMCHANGED') {
        toast.success('Room changed successfully!')

        setConfirmChecked(false)
        setAllotModalOpen(false)
        setSelectedRoomId(null)
        setSelectedBedId(null)
        fetchFeeApprovedStudentList()
      }
    } catch (err) {
      toast.error('Something went wrong!')
    } finally {
      setLoading(false)
    }
  }

  // =======CSS==========
  const labelCss = {
    fontWeight: '600',
  }
  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.warning('No data available to export')
      return
    }

    const excelData = filteredData.map((item, index) => ({
      'Sr No': index + 1,
      'Student Name': item.full_name,
      'WhatsApp No': item.whats_no,
    }))

    const worksheet = XLSX.utils.json_to_sheet(excelData)

    worksheet['!cols'] = [{ wch: 8 }, { wch: 35 }, { wch: 20 }]

    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Room Change')

    XLSX.writeFile(workbook, 'Student_Room_Change_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Student Room Change</h2>
          </div>

          <div className="search-bar">
            {/* <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button> */}

            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
            className="shadow border rounded"
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ---------- VIEW MODAL ---------- */}

      <Modal
        title={null}
        open={viewModalOpen}
        onCancel={() => {
          setViewModalOpen(false)
          setConfirmChecked(false)
        }}
        footer={null}
        width={980}
      >
        {selectedRecord && (
          <div className="py-4 px-md-4">
            {/* HEADER */}
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Student Details
            </h3>

            <div
              className="border rounded shadow p-2 p-md-4"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-12 py-2">
                        <span style={labelCss}>Full Name:</span>
                        <br />
                        <span
                          style={{
                            fontSize: '18px',
                            backgroundColor: '#f8ff90ff',
                            padding: '2px 10px',
                          }}
                        >
                          {selectedRecord.s_fname} {selectedRecord.s_mname}{' '}
                          {selectedRecord.s_lname}
                        </span>
                      </div>
                      <div className="col-md-4 py-2">
                        <span style={labelCss}>Mobile:</span>
                        <br /> {selectedRecord.mobile}
                      </div>
                      <div className="col-md-4 py-2">
                        <span style={labelCss}>WhatsApp No:</span>
                        <br /> {selectedRecord.wh_mobile || '-'}
                      </div>
                      <div className="col-md-4 py-2">
                        <span style={labelCss}>Email:</span>
                        <br /> {selectedRecord.email}
                      </div>
                      <div className="col-md-12 py-2">
                        <span style={labelCss}>Address:</span>
                        <br /> {selectedRecord.address},{' '}
                        {selectedRecord.village}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-4">
                        <span style={labelCss}>Building Name:</span>
                        <p
                          className="shadow py-3 px-3 rounded"
                          style={{ backgroundColor: '#f1e0bf' }}
                        >
                          {selectedRecord.roombooking.class.class_name}
                        </p>
                      </div>
                      <div className="col-md-4">
                        <span style={labelCss}>Room No:</span>
                        <p
                          className="shadow py-3 px-3 rounded"
                          style={{ backgroundColor: '#dee9fc' }}
                        >
                          {selectedRecord.roombooking.room.room_no}
                        </p>
                      </div>
                      <div className="col-md-4">
                        <span style={labelCss}>Bed No:</span>
                        <p
                          className="shadow py-3 px-3 rounded"
                          style={{ backgroundColor: '#d6fce3' }}
                        >
                          {selectedRecord.roombooking.bed.bed_no}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4 p-3">
              {/* Confirm Checkbox */}
              <div className="d-flex align-items-center mb-3">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  style={{ border: '1px solid black' }}
                  checked={confirmChecked}
                  onChange={(e) => setConfirmChecked(e.target.checked)}
                />
                <label style={{ fontSize: '15px', fontWeight: '500' }}>
                  I confirm all details are checked and verified
                </label>
              </div>

              {/* Buttons */}
              <div className="d-flex gap-3 mt-3">
                <Button
                  danger
                  disabled={!confirmChecked}
                  onClick={() => {
                    setViewModalOpen(false)
                    setConfirmChecked(false)
                  }}
                >
                  Cancel
                </Button>

                <Button
                  type="primary"
                  disabled={!confirmChecked}
                  loading={loading}
                  onClick={() => {
                    setViewModalOpen(false)
                    setAllotModalOpen(true)
                    setConfirmChecked(false)
                    fetchClasses()
                  }}
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* =================== ROOM CHANGE MODAL =================== */}
      <Modal
        // className="custom-alloc-modal"
        title="Room Change"
        open={allotModalOpen}
        onCancel={() => {
          setAllotModalOpen(false)
          setSelectedRoomId(null)
          setSelectedBedId(null)
          setSelectedClassId(null)
        }}
        width={900}
        footer={null}
      >
        {/* ===== CLASS SELECTION ===== */}
        <h5 className="section-title">Select Class</h5>
        <div className="row">
          {classes.map((cls) => {
            const isSelected = selectedClassId === cls.class_id

            return (
              <div className="col-md-3 mb-3" key={cls.class_id}>
                <div
                  className={`room-card ${isSelected ? 'room-selected' : ''}`}
                  onClick={() => {
                    setSelectedClassId(cls.class_id)
                    setSelectedRoomId(null)
                    setSelectedBedId(null)
                    fetchRooms(cls.class_id) // 👈 fetch rooms here
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <b>{cls.class_name}</b>
                </div>
              </div>
            )
          })}
        </div>

        {/* Rooms */}
        {selectedClassId && (
          <>
            <h5 className="section-title">Select Room</h5>
            <div className="row">
              {Array.isArray(rooms) && rooms.length > 0 ? (
                rooms.map((room) => {
                  {/* const isOccupied = room.status === 2 */}
                  const isSelected = selectedRoomId === room.room_id
                  const currentRoomId = selectedRecord?.roombooking?.room_id;

                  const isCurrentRoom = room.room_id === currentRoomId;

                  const isOccupied = room.status === 2;

                  const blocked = isOccupied && !isCurrentRoom;

                  return (
                    <div className="col-md-3 mb-3" key={room.room_id}>
                      <div
                        className={`room-card
                    
                    ${isSelected ? 'room-selected' : ''}
                  `}
                        onClick={() => {
                          setSelectedRoomId(room.room_id);
                          setSelectedBedId(null);
                          fetchBeds(room.room_id);
                        }}

                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <b>Room {room.room_no}</b>
                        <br />
                        {/* {isOccupied && <small>(Occupied)</small>} */}
                        {/* { blocked && <small>(Occupied)</small> }
                        { isCurrentRoom && <small>(Current Room)</small> } */}
                      </div>
                    </div>
                  )
                })
              ) : (
                <p style={{ color: 'gray' }}>No rooms available</p>
              )}
            </div>
          </>
        )}

        {/* Beds */}
        {selectedRoomId && (
          <>
            <h5 className="section-title">Select Bed</h5>
            <div className="row">
              {beds.map((bed) => {
                {/* const bedOccupied = bed.status === 2
                const bedSelected = selectedBedId === bed.bed_id */}
                const currentBedId = selectedRecord?.roombooking?.bed_id;

                const isCurrentBed = bed.bed_id === currentBedId;

                const blocked = bed.status === 2 || isCurrentBed;

                const bedSelected = selectedBedId === bed.bed_id;

                return (
                  <div className="col-md-3 mb-3" key={bed.bed_id}>
                    <div
                      className={`
                                bed-card
                                ${blocked ? "bed-occupied" : ""}
                                ${bedSelected ? 'bed-selected' : ''}
                                `}
                      onClick={() => {
                        if (!blocked) {
                          setSelectedBedId(bed.bed_id)
                        }
                      }}
                      style={{
                        cursor: blocked ? 'not-allowed' : 'pointer',
                      }}
                    >
                      <b>{bed.bed_no}</b>
                      <br />
                      {/* {bedOccupied ? 'Occupied' : 'Available'} */}
                      { isCurrentBed ? "Current Bed" : bed.status === 2 ? "Occupied" : "Available" }
                    </div>
                  </div>
                )
              })}
            </div>
          </>
        )}

        {/* Buttons */}
        <div className="d-flex justify-content-end gap-3 mt-3">
          <Button
            danger
            onClick={() => {
              setAllotModalOpen(false)
              setSelectedRoomId(null)
              setSelectedClassId(null)
              setSelectedBedId(null)
            }}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            disabled={!selectedClassId || !selectedRoomId || !selectedBedId}
            loading={loading}
            onClick={() => {
              setAllotModalOpen(false)
              handleApproval()
            }}
          >
            Change
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default StudentRoomChange
